/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_Any_Skunk_ConquerInputs */

const en_clear_any_skunk_conquer = /** @type {(inputs: Clear_Any_Skunk_ConquerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery plans`)
};

const de_clear_any_skunk_conquer = /** @type {(inputs: Clear_Any_Skunk_ConquerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umfragepläne`)
};

/**
* | output |
* | --- |
* | "Delivery plans" |
*
* @param {Clear_Any_Skunk_ConquerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const clear_any_skunk_conquer = /** @type {((inputs?: Clear_Any_Skunk_ConquerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_Any_Skunk_ConquerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clear_any_skunk_conquer(inputs)
	return de_clear_any_skunk_conquer(inputs)
});